import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import ReactECharts from "echarts-for-react";

const LineChart = ({ score = {}, maxScore }) => {
  const [categories, setCategories] = useState([]);
  const [seriesData, setSeriesData] = useState([]);

  useEffect(() => {
    if (score && Object?.keys(score)?.length > 0) {
      const processedCategories = [];
      const processedScores = [];

      Object.entries(score)?.forEach(([year, scores]) => {
        if (Array.isArray(scores) && scores?.length > 0) {
          scores?.forEach((data, index) => {
            processedCategories.push(`${year}-${index + 1}`);
            processedScores.push({
              year,
              score: data?.score ?? null,
              result: data?.result || "No result",
              date: data?.date ?? null,
            });
          });
        } else {
          processedCategories.push(year);
          processedScores.push({ year, score: 0, result: "No result" });
        }
      });
      setCategories((prev) =>
        JSON.stringify(prev) === JSON.stringify(processedCategories)
          ? prev
          : processedCategories
      );
      setSeriesData((prev) =>
        JSON.stringify(prev) === JSON.stringify(processedScores)
          ? prev
          : processedScores
      );
    }
  }, [score]);

  const option = {
    tooltip: {
      trigger: "axis",
      formatter: (params) => {
        const dataIndex = params[0]?.dataIndex;
        const dataPoint = seriesData[dataIndex];

        return `
          ${
            dataPoint?.date
              ? dayjs(dataPoint?.date)?.format("MM/DD/YYYY")
              : dataPoint?.year
          }  <br/>
          Result: ${dataPoint.result}<br/>
          Score: ${dataPoint.score !== null ? dataPoint.score : "N/A"}<br/>
        `;
      },
    },
    xAxis: {
      type: "category",
      data: categories?.map((label) => label.split("-")[0]),
      axisLabel: {
        formatter: (value, index) => {
          return index === 0 || categories[index - 1].split("-")[0] !== value
            ? value
            : "";
        },
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      type: "value",
      min: 0,
      max: maxScore,
      name: "Score",
    },
    series: [
      {
        data: seriesData?.map((data) =>
          data.score !== null ? data.score : null
        ),
        type: "line",
        smooth: false,
        lineStyle: {
          color: "#82C799",
        },
        itemStyle: {
          color: "#1780C6",
        },
        symbolSize: 6,
        connectNulls: true,
      },
    ],
    grid: {
      left: "6%",
      right: "4%",
      bottom: "7%",
      containLabel: true,
    },
    color: ["#82C799"],
  };

  return (
    <div id="chart">
      <ReactECharts option={option} style={{ height: 270 }} />
    </div>
  );
};

export default LineChart;
